export default [
  {
    path: "/settings/routes",
    name: "Routes",
    component: () => import("@/views/3pl/Settings/RoutesAndVehicles/index"),
  },
  {
    path: "/settings/routes/newterminal-to-terminal",
    name: "NewTerminalToTerminalRoute",
    component: () => import("@/views/3pl/Settings/RoutesAndVehicles/NewTerminalToTerminalRoute"),
  },
  {
    path: "/settings/routes/new-terminal-to-door",
    name: "NewTerminalToDoorRoute",
    component: () => import("@/views/3pl/Settings/RoutesAndVehicles/NewTerminalToDoorRoute"),
  },
  {
    path: "/settings/routes/new-door-to-door",
    name: "NewDoorToDoorRoute",
    component: () => import("@/views/3pl/Settings/RoutesAndVehicles/NewDoorToDoorRoute"),
  },
  // {
  //   path: "/settings/routes/new",
  //   name: "NewRoute",
  //   component: () => import("@/views/3pl/Settings/RoutesAndVehicles/NewRoute"),
  // },
  // {
  //   path: "/settings/routes/old",
  //   name: "OldRoute",
  //   component: () => import("@/views/3pl/Settings/RoutesAndVehicles/Routes/NewRoute"),
  // },
  {
    path: "/settings/routes/view-terminal-to-terminal",
    name: "EditTerminalToTerminal",
    component: () =>
      import("@/views/3pl/Settings/RoutesAndVehicles/EditTerminalToTerminal"),
  },
  {
    path: "/settings/routes/view-terminal-to-door",
    name: "EditTerminalToDoor",
    component: () =>
      import("@/views/3pl/Settings/RoutesAndVehicles/EditTerminalToDoor"),
  },
  {
    path: "/settings/routes/view-door-to-door",
    name: "EditDoorToDoor",
    component: () =>
      import("@/views/3pl/Settings/RoutesAndVehicles/EditDoorToDoor"),
  },
  {
    path: "/settings/routes/view/edit-last-mile",
    name: "EditLastMile",
    component: () =>
      import("@/views/3pl/Settings/RoutesAndVehicles/EditLastMile"),
  },
  {
    path: "/settings/routes/view/edit-route-schedule",
    name: "EditRouteSchedule",
    component: () =>
      import("@/views/3pl/Settings/RoutesAndVehicles/EditRouteSchedule"),
  },
];
